import React from 'react'
import {Draggable} from 'react-beautiful-dnd'
import Published from 'Event/Dashboard/editor/views/Published'
import Configurable from 'organization/Event/Configurable'
import VisibleOnMatch from 'Event/attendee-rules/VisibleOnMatch'
import {Agenda} from 'Event/template/Panels/Dashboard/AgendaList'
import {AgendaItemConfig} from 'Event/template/Panels/Dashboard/AgendaList/AgendaItemConfig'
import {useDuplicateAgenda} from 'Event/template/Panels/Dashboard/AgendaList/use-duplicate-agenda'

type EditableAgendaItemProps = {
  agenda: Agenda
  id: string
  index: number
  children: React.ReactElement
}

export default function EditableAgendaItem(props: EditableAgendaItemProps) {
  const {agenda, id, index, children} = props
  const duplicate = useDuplicateAgenda()

  return (
    <Draggable draggableId={id} index={index}>
      {(provided) => (
        <Configurable
          aria-label="agenda item config"
          editableProps={{
            handleProps: provided.dragHandleProps,
            onCopy: () => duplicate(id),
          }}
        >
          <AgendaItemConfig agenda={agenda} id={id} />
          <div ref={provided.innerRef} {...provided.draggableProps}>
            <VisibleOnMatch rules={agenda.rules}>
              <Published component={agenda}>{children}</Published>
            </VisibleOnMatch>
          </div>
        </Configurable>
      )}
    </Draggable>
  )
}
